import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { VersionCheckService } from './service/version-check.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'FT Pilot';

  constructor(
    private versionCheckService: VersionCheckService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.versionCheckService.start();
  }

  /** Clique único e óbvio no toast de nova versão — sem auto-reload forçado. */
  reloadApp(): void {
    window.location.reload();
  }

  dismissAppUpdate(): void {
    this.messageService.clear('appUpdate');
  }
}